import { FC, ReactNode } from "react";
import { Form, Input } from "antd";
import { ProColumns } from "@ant-design/pro-table";
import { connect } from "react-redux";
import { RootState } from "reducers";
import SearchBox from "components/search-box";
import LevelDetails from "./level-details";
import { deleteEntity, getEntities, getEntity } from "./level.reducer";
import { RouteComponentProps } from "@reach/router";
import ListViewPage from "layouts/page-wraper/list-view-page";
import LevelEdit from "./level-edit";
import { Level } from "model/customerCore/level.model";


export interface LevelListProps
  extends StateProps, DispatchProps, RouteComponentProps {
  children?: ReactNode;
}
const columns: ProColumns<Level>[] = [{
  title: '级别名称',
  dataIndex: 'levelName',
}, {
  title: '级别编号',
  dataIndex: 'levelNo',
}, {
  title: '账户类型',
  dataIndex: 'walletAccountType',
}, {
  title: '排序',
  dataIndex: 'levelSort',
}];


const LevelList: FC<LevelListProps> = (props) => {
  const searchFields = [{
    label: '级别名称',
    name: 'levelName.contains',
  }];

  const quickFilterPanel = (
    <Form.Item>
      <Input.Group compact>
        <SearchBox
          fields={searchFields}
        />
      </Input.Group>
    </Form.Item>
  );
  return (
    <ListViewPage<Level>
      columns={columns}
      quickFilterPanel={quickFilterPanel}
      detailPage={<LevelDetails navigate={props.navigate} columns={columns} />}
      detailsIndex={false}
      editPage={(params: any) => <LevelEdit id={params.id} text={params.text} />}
      sort="levelNo,asc"
      {...props}
    >
      {props.children}
    </ListViewPage>
  );
};

const mapStateToProps = ({ level }: RootState) => ({
  entity: level.entity,
  entities: level.entities,
  loading: level.loading,
  updateSuccess: level.updateSuccess,
  createSuccess: level.createSuccess,
  total: level.total
});

const mapDispatchToProps = {
  getEntity,
  getEntities,
  deleteEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(LevelList);